import { useState } from "react";

export const useFaq = ({ faqs = [] }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return {
        faqs,
        openIndex,
        toggle
    }
}